/* global axios */
import ApiClient from '../ApiClient';

class NexceoProjectDocumentsAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  get(projectId, params = {}) {
    return axios.get(`${this.url}/${projectId}/documents`, { params });
  }

  show(projectId, documentId) {
    return axios.get(`${this.url}/${projectId}/documents/${documentId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  buildFormData(payload, file, thumbnail) {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (v !== null && v !== undefined) fd.append(`document[${k}]`, v);
    });
    if (file) fd.append('document[document_file]', file);
    if (thumbnail) fd.append('document[thumbnail]', thumbnail);
    return fd;
  }

  create(projectId, payload, file = null, thumbnail = null) {
    if (file || thumbnail) {
      const fd = this.buildFormData(payload, file, thumbnail);
      return axios.post(`${this.url}/${projectId}/documents`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(`${this.url}/${projectId}/documents`, {
      document: payload,
    });
  }

  update(projectId, documentId, payload, file = null, thumbnail = null) {
    if (file || thumbnail) {
      const fd = this.buildFormData(payload, file, thumbnail);
      return axios.patch(
        `${this.url}/${projectId}/documents/${documentId}`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    }
    return axios.patch(`${this.url}/${projectId}/documents/${documentId}`, {
      document: payload,
    });
  }

  archive(projectId, documentId) {
    return axios.delete(`${this.url}/${projectId}/documents/${documentId}`);
  }

  approveForAi(projectId, documentId) {
    return axios.post(
      `${this.url}/${projectId}/documents/${documentId}/approve_for_ai`
    );
  }

  revokeAiApproval(projectId, documentId) {
    return axios.post(
      `${this.url}/${projectId}/documents/${documentId}/revoke_ai_approval`
    );
  }

  markCustomerShareable(projectId, documentId) {
    return axios.post(
      `${this.url}/${projectId}/documents/${documentId}/mark_customer_shareable`
    );
  }

  unmarkCustomerShareable(projectId, documentId) {
    return axios.post(
      `${this.url}/${projectId}/documents/${documentId}/unmark_customer_shareable`
    );
  }
}

export default new NexceoProjectDocumentsAPI();
